import { SVGProps } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'


export const ExpandIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon  {...props}>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
      <path d="M14 6V2H10 M2 10V14H6 M14 2L9 7 M7 9L2 14" stroke="#00598E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    </SvgIcon>
  )
}